/**
 * Customer measurements (POS Settings → "Customer measurements",
 * POS_CustomerMeasurements; migration 078, pos_customer_measurements).
 *
 * The list a thobe tailor needs, in centimetres. It is DATA, not schema: the
 * values are stored as JSON keyed by `key`, so adding, renaming or reordering
 * a measurement is an edit to this list only — no migration, no API change
 * (the server accepts any well-formed key). Never REUSE a key for a different
 * measurement: stored values would silently change meaning. Retire it instead.
 */

export interface CustomerMeasurementField {
  key: string;
  en: string;
  ar: string;
  /** Shown under the label. */
  hintEn?: string;
  hintAr?: string;
}

export const CUSTOMER_MEASUREMENT_FIELDS: readonly CustomerMeasurementField[] = [
  { key: 'length', en: 'Length', ar: 'الطول', hintEn: 'Shoulder to heel', hintAr: 'من الكتف لحد الكعب' },
  { key: 'shoulder', en: 'Shoulder width', ar: 'عرض الكتف' },
  { key: 'sleeve', en: 'Sleeve length', ar: 'طول الكم', hintEn: 'Shoulder to wrist', hintAr: 'من الكتف لحد المعصم' },
  { key: 'chest', en: 'Chest', ar: 'وسع الصدر' },
  { key: 'waist', en: 'Waist / belly', ar: 'وسع الوسط / البطن' },
  { key: 'hips', en: 'Hips', ar: 'وسع الحوض (الورك)' },
  { key: 'hem', en: 'Hem width', ar: 'وسع أسفل الثوب (الذيل)' },
  { key: 'neck', en: 'Neck', ar: 'محيط الرقبة', hintEn: 'For the collar', hintAr: 'لمقاس الياقة' },
  { key: 'upper_arm', en: 'Upper arm', ar: 'وسع الزند', hintEn: 'Top of the arm', hintAr: 'أعلى الذراع' },
  { key: 'wrist', en: 'Wrist (cuff)', ar: 'وسع المعصم (الكبك)' },
  { key: 'chest_opening', en: 'Chest opening length', ar: 'طول فتحة الصدر (الجبزور)' },
  { key: 'pocket', en: 'Pocket length', ar: 'طول الجيب' },
];

export type CustomerMeasurementType = 'cash' | 'credit';

/** key → centimetres; a measurement not taken is absent (or null). */
export type CustomerMeasurementValues = Record<string, number | null>;

export interface CustomerMeasurementsDto {
  customer_type: CustomerMeasurementType;
  customer_id: number;
  values: CustomerMeasurementValues;
  notes: string | null;
  updated_at: string | null;
  /** False until migration 078 reaches the tenant — the dialog says so. */
  available: boolean;
}
